import MUIButton from '@mui/material/Button';
import { Typography } from '@mui/material';
import styled from 'styled-components';

export const LinkButton = styled(MUIButton)`
  text-align: left;
  text-transform: none;
  height: 60px;
  display: flex;
  justify-content: flex-start;
`;

export const SubmitButton = styled(MUIButton)`
  text-transform: none;
  font-weight: bold;
  font-size: 1.15rem;
`;

export const CustomMessageLabel = styled(Typography)`
  color: #606060;
  margin-bottom: 10px;
`;